<script setup lang="ts">

//vue
import { onMounted, reactive,} from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataUS, fdataUSS, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

//componentes
import Pesquisa from "./Pesquisa.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import Loading from "@/components/Loading/index.vue"

//janelas
import GerarRemessa from "./GerarRemessa.vue"
import ImportarRetorno from "./ImportarRetorno.vue"


interface configColuna {
    coluna: string,
    exibe: boolean
}

interface BoletoDto extends service.Boleto {
    marcado: boolean
}

var controle = reactive({
    filtros :{
        nome: "",
        dataCadIni: undefined,
        dataCadFim: undefined,
        dataVencIni: undefined,
        dataVencFim: undefined,
        nossoNumero: undefined,
        numeroDocumento: undefined,
        status: undefined,
    } as service.ConsultaPeriodoApiFiltros,
    boletos: [] as BoletoDto[],
    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    marcarTodos: false,
    totais: {
        qtde: 0,
        total: 0,
    },


    janDetalhes: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});


onMounted(() => {
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.boletos = [] as BoletoDto[];

    service.consultarBoletosPeriodoApi(controle.filtros)
        .then((r) => {
            console.log("retorno: ", r);
            controle.pesquisando = false;
            controle.status = "";
            // controle.boletos = r.dados as BoletoDto[];
            // controle.totalRegistros = r.totalRegistros;

            // controle.totais.total = 0;

            // controle.boletos.forEach((boleto) => {

            //     controle.totais.qtde++;

            //     controle.totais.total += (boleto.valorDocumento ?? 0);


            //     //marca os boletos que estavam marcados
            //     // var marcado = controle.marcados.find(a => a.boletoId == boleto.boletoId);
            //     // if (marcado != undefined && marcado != null) {
            //     //     console.log("marcado: ", marcado);
            //     //     boleto.marcado = true;
            //     // }
            // });

        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};


const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}


function marcarTodos() {
    
    controle.boletos.forEach(item => {
        item.marcado = controle.marcarTodos;
    });

}
</script>

<template>

    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <div class="p-2 bg-light">
        <div class="row">
            <div class="col-md-12 col-12 fs-6 fw-bold">
                Consulta de Boletos no Banco
            </div>
        </div>

        <Pesquisa @onPesquisar="pesquisar"></Pesquisa>

        <div class="col-md-12 div-table-boletos box-table">
            <table class="table table-striped table-hover table-sm">
                <thead class="th-fixed">
                    <tr>
                        <th class="text-start" @click="ordenarPor('dataPedido')" >Banco</th>
                        <th class="text-center">Opções</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-show="controle.pesquisando == true">
                        <td colspan="15" class="text-center">
                            <div class="d-inline">
                                <i class="fa fa-cog fa-spin"></i>
                                Pesquisando... 
                            </div>
                        </td>
                    </tr>

                    
                    <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                        <td colspan="15" class="text-center">
                            <div class="d-inline">
                                <i class="fa fa-exclamation"></i>
                                {{ controle.erro }}
                            </div>
                            <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                        </td>
                    </tr>

                    <tr v-for="(item, idx) in controle.boletos" :key="idx" :class="item.marcado == true ? 'table-active' : ''"
                        @click="controle.boletoId = item.boletoId; controle.boleto = item">

                        <td class="text-start" data-label="Banco" >
                            {{ item.banco }}
                        </td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <nav class="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    
                    
                   


                </ul>

                

                <div class="d-flex">
                    <ul class="navbar-nav">

                       <li class="nav-item">
                            <a class="nav-link" href="#">Boletos: [{{ controle.boletos?.length }}] - R$ {{ f2dec(controle.totais?.total) }} </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">Selecionado: [{{ controle.boletos.filter(a=> a.marcado == true).length }}] - 
                                R$ {{ f2dec(controle.boletos.filter(a=> a.marcado == true).reduce((total, boleto) => total + (boleto.valorDocumento ?? 0), 0)) }}
                            </a>
                        </li>
                        
                        <li class="nav-item">
                            <router-link to="/" class="nav-link">
                                <i class="fa fa-close"></i> Fechar
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
   


</template>

<style scoped>

.div-table-boletos {
    max-height: calc(100vh - 200px);
    min-height: calc(100vh - 200px);
    overflow: auto;
}

.badge {
    font-size: 100%;
    cursor: pointer;
    text-wrap: wrap;
}

.table-selecao {
    color: #fff !important;
    background-color: #003b93 !important;
    --bs-table-bg-state: #0d6efd;
    --bs-table-color-state: #fff;
}

.opcoes {
    min-width: 95px;
}
</style>